module.exports = __webpack_public_path__ + "991b43b923dfada87c027cbe0efdb28e.png";